import { Button } from "@material-ui/core";
import { contact } from "../config/Contact";

type Props = {
  email: string;
  subject: {
    ja: string;
    en: string;
  };
  body: {
    ja: string;
    en: string;
  };
  lang: string;
};

export default ({ email, subject, body, lang }: Props) => (
  <Button
    style={{ textAlign: "unset", textTransform: "none" }}
    aria-label="email"
  >
    <div
      style={{
        fontSize: "14px",
      }}
    >
      <a
        href={`mailto:${email}?subject=${
          lang === "ja" ? subject.ja : subject.en
        }&body=${lang === "ja" ? body.ja : body.en}`}
        target="_blank"
        style={{ color: "#4d4d4d", textDecoration: "none" }}
      >
        {email}
      </a>
    </div>
  </Button>
);
